import PersonGroups from 'containers/pages/persons/PersonGroups';

const PersonGroupsTab = () => {
  return <PersonGroups />;
};

export default PersonGroupsTab;
